@use '~/theme/theme' as *;
@use '~/theme/typography';

.valueContainer {
  font-family: 'Public Sans', sans-serif;
  border-radius: 8px;
  border: 1px solid var(--border-color);
  background: white;
  display: flex;
  align-items: center;
  width: 100%;
}

.addonWrapper {
  display: flex;
  align-items: center;
  width: 100%;
}

.addon {
  background: var(--addon-background);
  border: var(--addon-border);
  color: var(--addon-color);
}

.endAddon {
  border-left: none;
  border-radius: 0 8px 8px 0;
}

.endIcon {
  flex-shrink: 0;
  margin-left: spacing(1);
  color: var(--icon-color);
}

.comboContainer {
  position: relative;
  flex-grow: 1;

  .media {
    pointer-events: none;
    position: absolute;
    left: 12px;
    height: 100%;
    width: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .valueContainer {
    width: 100%;
    padding-left: 12px;
  }

  &:has(.media) .valueContainer {
    padding-left: 44px;
  }

  button {
    background: none;
    position: absolute;
    right: 0;
    top: 0;
    border: 0;
  }

  input {
    &[data-disabled] {
      &::placeholder {
        color: #{color(grey-500)};
      }

      background-color: #{color(grey-100)};

      --border-color: #{color(grey-400)};

      color: #{color(grey-500)};
    }
  }
}
/* stylelint-disable no-descending-specificity */
.comboBoxField {
  --border-color: #{color(grey-600)};
  --addon-background: white;
  --addon-border: #{border(grey-600)};
  --addon-color: #{color(grey-600)};

  cursor: pointer;

  --icon-color: #{color(grey-800)};

  &[data-focused] .valueContainer {
    --border-color: #{color(violet-600)};

    outline: 1px solid var(--border-color);
  }

  &[data-invalid] {
    --border-color: #{color(lobster-800)};
  }

  &[data-disabled] {
    --addon-border: #{border(grey-400)};
    --addon-color: #{color(grey-500)};
    --addon-background: #{color(grey-100)};
  }

  &:has(.endAddon) .valueContainer {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
}

.comboBoxField[data-size='small'] {
  .valueContainer {
    @include typography.caption;
    @include typography.medium;

    height: 32px;

    &:has(+ button) {
      padding-right: 36px;
    }
  }

  button {
    width: 24px;
    height: 24px;
    padding: 0;
    top: 4px;
    right: 12px;
    border-radius: 4px;
  }

  .clearButton {
    right: 40px;
  }

  .addon {
    @include typography.caption;
    @include typography.medium;

    padding: 5px 12px;
  }
}

.comboBoxField[data-size='medium'] {
  .valueContainer {
    @include typography.body2;
    @include typography.regular;

    height: 38px;

    &:has(+ button) {
      padding-right: 42px;
    }

    &:has(+ button + button) {
      padding-right: 68px;
    }
  }

  button {
    width: 24px;
    height: 24px;
    padding: 0;
    top: 7px;
    right: 12px;
    border-radius: 4px;
  }

  .clearButton {
    right: 40px;
  }

  .addon {
    @include typography.body2;
    @include typography.medium;

    padding: 7px 16px;
  }
}

.comboBoxField[data-size='large'] {
  .valueContainer {
    @include typography.body1;
    @include typography.regular;

    height: 48px;

    &:has(+ button) {
      padding-right: 42px;
    }
  }

  button {
    top: 0;
    right: 0;
  }

  .addon {
    @include typography.body1;
    @include typography.regular;

    padding: 11px 16px;
  }
}
/* stylelint-enable no-descending-specificity */
